window.addEventListener('DOMContentLoaded', () => {
    const announcementBar = document.querySelector('.announcement-bar-section');
    const desktopWrapper = document.querySelector('.section-header');
    const mobileWrapper = document.querySelector('.section-mobile-header');
    const closeBtn = announcementBar?.querySelector('.announcement-bar_closeBtn');
    const utilityBar = announcementBar?.querySelector('.utility-bar');
    const showDays = utilityBar ? parseInt(utilityBar.getAttribute('show-announcement-bar'), 10) : 0;

    const setCookie = (name, value, days) => {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
    };

    const getCookie = (name) => {
        const nameEQ = name + "=";
        const cookiesArray = document.cookie.split(';');
        for (let i = 0; i < cookiesArray.length; i++) {
            let cookie = cookiesArray[i].trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length, cookie.length);
            }
        }
        return null;
    };

    function updateEl(el, top, pos = 'sticky', trans = 'top 0.15s ease-in-out') {
        if (!el) return;
        el.style.position = pos;
        el.style.top = top;
        el.style.transition = trans;
    }
    function hideEl(el) { updateEl(el, '-200px'); }
    function staticEl(el) { updateEl(el, '', 'static', ''); }

    let stickyOffsetRafId = null;
    window.updateStickyOffset = function() {
        if (stickyOffsetRafId) return;
        stickyOffsetRafId = requestAnimationFrame(() => {
            stickyOffsetRafId = null;
            let offset = 0;
            const stickyAtcBar = document.querySelector('.sticky-atc-bar.is-visible');
            const els = [announcementBar, desktopWrapper, mobileWrapper, stickyAtcBar];
            for (let i = 0; i < els.length; i++) {
                const el = els[i];
                if (!el || el.classList.contains('hidden')) continue;
                const bottom = el.getBoundingClientRect().bottom;
                if (bottom > offset && bottom > 0) offset = bottom;
            }
            document.documentElement.style.setProperty('--header-sticky-offset', offset + 'px');
        });
    }

    // Helper to get the currently active header (desktop or mobile)
    function getActiveHeader() {
        return desktopWrapper?.offsetHeight ? desktopWrapper : mobileWrapper;
    }

    // Cache DOM position check - this never changes after page load
    const isAnnouncementAboveHeader = (() => {
        if (!announcementBar || (!desktopWrapper && !mobileWrapper)) return false;
        const headerEl = getActiveHeader();
        // Use compareDocumentPosition to check DOM order, not rendered position
        const position = announcementBar.compareDocumentPosition(headerEl);
        // DOCUMENT_POSITION_FOLLOWING (4) means headerEl comes after announcementBar in DOM
        return (position & Node.DOCUMENT_POSITION_FOLLOWING) !== 0;
    })();


    closeBtn?.addEventListener('click', () => {
        announcementBar?.classList.add("hidden");
        desktopWrapper.style.top = '0';
        mobileWrapper.style.top = '0';
        setCookie('announcementBarClosed', 'true', showDays);
        window.updateStickyOffset();
    });

    const isAnnouncementBarClosed = getCookie('announcementBarClosed');

    if (isAnnouncementBarClosed !== 'true') {
        announcementBar?.classList.remove("hidden");
    } else {
        announcementBar?.classList.add("hidden");
        if (desktopWrapper) desktopWrapper.style.top = '0';
        if (mobileWrapper) mobileWrapper.style.top = '0';
    }

    const barHeight = (!isAnnouncementBarClosed && announcementBar && isAnnouncementAboveHeader)
        ? announcementBar.offsetHeight + 'px'
        : '0';

    const dt = desktopWrapper?.querySelector('header[data-sticky-type]')?.getAttribute('data-sticky-type') || desktopWrapper?.getAttribute('data-sticky-type');
    const mt = mobileWrapper?.querySelector('header[data-sticky-type]')?.getAttribute('data-sticky-type') || mobileWrapper?.getAttribute('data-sticky-type');

    if (dt === 'always' || dt === 'on-scroll-up') {
        updateEl(desktopWrapper, barHeight);
    } else {
        staticEl(desktopWrapper);
    }

    if (mt === 'always' || mt === 'on-scroll-up') {
        updateEl(mobileWrapper, barHeight);
    } else {
        staticEl(mobileWrapper);
    }

    // Set initial announcement bar position if it's below the header
    if (!isAnnouncementBarClosed && announcementBar && !isAnnouncementAboveHeader) {
        const activeHeader = getActiveHeader();
        const headerHeight = activeHeader ? activeHeader.offsetHeight + 'px' : '0';
        updateEl(announcementBar, headerHeight);
    }

    window.updateStickyOffset();

    let lastY = window.pageYOffset;
    const threshold = 5;
    let scrollTimeout;

    window.addEventListener('scroll', () => {
        const y = window.pageYOffset;
        if (Math.abs(y - lastY) > threshold) {
            if (y > lastY) {
                clearTimeout(scrollTimeout);
                // Only hide on scroll down if sticky type is NOT 'always'
                const activeType = desktopWrapper?.offsetHeight ? dt : mt;
                if (activeType !== 'always') hideEl(announcementBar);
                if (dt !== 'always') hideEl(desktopWrapper);
                if (mt !== 'always') hideEl(mobileWrapper);
                window.updateStickyOffset();
            } else {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(() => {
                    if (!isAnnouncementBarClosed) {
                        if (isAnnouncementAboveHeader) {
                            // Announcement bar is above header - put it at top
                            updateEl(announcementBar, '0');
                        } else {
                            // Announcement bar is below header - put it below the header
                            const activeHeader = getActiveHeader();
                            const headerHeight = activeHeader ? activeHeader.offsetHeight + 'px' : '0';
                            updateEl(announcementBar, headerHeight);
                        }
                    }

                    const newBarHeight = (!isAnnouncementBarClosed && announcementBar && isAnnouncementAboveHeader)
                        ? announcementBar.offsetHeight + 'px'
                        : '0';
                    if (dt !== 'none') updateEl(desktopWrapper, newBarHeight);
                    if (mt !== 'none') updateEl(mobileWrapper, newBarHeight);
                    window.updateStickyOffset();
                }, 200);
            }
            lastY = y;
        }
    });
});